import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';

import { PatientProfile, PatientHCProviders, PatientInteractionsWidget } from 'screens'

const DRAWER_WIDTH = 300//'40%'

const useStyles = makeStyles(theme => ({
    details: {
        display: 'contents',
        alignItems: 'start',
        flexDirection: 'row',
        width: DRAWER_WIDTH,
        marginLeft: theme.spacing(2),
        maxWidth: 300,
        minWidth: 300, 
        minHeight: 800,
        overflowY: 'scroll'
    }
}))

let widgetsOverride = [{
    name: 'PatientProfile',
    title : "profileWidget.title",
    component: PatientProfile
}, {
    name: 'PatientInteractions',
    title : "interactionsWidget.title",
    component: PatientInteractionsWidget
}, {
    name: 'PatientHCProviders',
    title : "hcpsWidget.title",
    component: PatientHCProviders
}]

const getWidgets = (widgets, views) => {
    return widgets.map(widget => {
        const view = (views || []).find(view => view.name === widget.name)
        if (view) {
            widget = Object.assign({...view}, widget)   
        }
        
        return widget
    })
}

const PatientDetails = ({ record, context }) => {
    const views = useSelector(state => state.application.data.views)
    const [widgets] = useState(getWidgets(widgetsOverride, views))
    const classes = useStyles()

    return (
        <div className={classes.details}>
            {widgets && widgets.map(({ component: Component, ...others }, index) => {
                return (
                    <Component
                        key={index}
                        record={record}
                        context={context}
                        {...others}
                    />
                )
            })}
        </div>
    )
}

export default PatientDetails